import { downloadFile } from '../../utils/files';
import { CACHE_TTL } from '../constants';

const { AuthenticatedHttp } = require('../../http/axios');

const subscriptionsCache = new Map();

function normalizeValue(v) {
  if (Array.isArray(v)) return [...v].sort();
  if (v === undefined) return '';
  if (v === null) return '';
  return v;
}

function buildKey(params) {
  const normalized = {};
  Object.keys(params || {})
    .sort()
    .forEach((k) => {
      normalized[k] = normalizeValue(params[k]);
    });
  return JSON.stringify(normalized);
}

export const clearSubscriptionsCache = () => {
  subscriptionsCache.clear();
};

export const getSuscriptionsService = async ({ page, limit, search, status, ...filter }) => {
  const params = { page, limit, search, status, ...filter };

  const key = buildKey(params);
  const now = Date.now();
  const cached = subscriptionsCache.get(key);

  if (cached) {
    if (cached.data && now - cached.ts < CACHE_TTL) return cached.data;
    if (cached.promise) return cached.promise;
  }

  const promise = AuthenticatedHttp.get(`/subscriptions/`, { params })
    .then(({ data }) => {
      subscriptionsCache.set(key, { data, ts: Date.now() });
      return data;
    })
    .catch((e) => {
      subscriptionsCache.delete(key);
      throw e;
    });

  subscriptionsCache.set(key, { promise, ts: now });

  return promise;
};

export const exportSuscriptionsService = async ({
  extension,
  page,
  limit,
  search,
  status,
  ...filter
}) =>
  AuthenticatedHttp.get(`/subscriptions/export/${extension}`, {
    params: {
      page,
      limit,
      search,
      status,
      ...filter,
    },
    responseType: 'blob',
  }).then((response) => {
    downloadFile({
      url: window.URL.createObjectURL(new Blob([response.data])),
      filename: `subscriptions.${extension}`,
    });
  });

export const cancelSybscription = async ({ id }) =>
  AuthenticatedHttp.post(`/subscriptions/${id}/cancel/`).then((response) => {
    clearSubscriptionsCache();
    return response;
  });

export const cancelProductSubscriptionsService = async ({ productId }) =>
  AuthenticatedHttp.post(`/subscriptions/product/${productId}/cancel/`).then((response) => {
    clearSubscriptionsCache();
    return response;
  });
